// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"1134dd1d","82":"b366a593","242":"e0b9dd49","453":"98ce39a2","531":"773ad459","939":"dc6c2a3f","961":"dd2ca813"}[chunkId] + ".chunk.js";
};